import Router from '@pages/users'
import UsersList from '@pages/users/list/list-users'

import UserRouter from '@pages/users/user/view-user'
import UserProfile from '@pages/users/user/profile/profile'
import UserMandate from '@pages/users/user/mandate/mandate'
import UserSubscription from '@pages/users/user/subscription/subscription'

import EntrepreneurRouter from '@pages/entrepreneurs/view-entrepreneur'
import EntrepreneurProfile from '@pages/entrepreneurs/edition/edit-profile'
import EntrepreneurActivity from '@pages/entrepreneurs/edition/edit-activity'
import EntrepreneurBilling from '@pages/entrepreneurs/edition/edit-billing'

import DocumentsRouter from '@pages/documents'
import DocumentsList from '@pages/documents/list/list-documents'
import DocumentInfos from '@pages/documents/edition/edit-document'

export default {
  path: 'freebe/',
  components: {
    default: Router,
  },

  children: [{
    path: '',
    redirect: () => ({
      name: 'users-list',
    })
  }, {
    path: 'users',
    name: 'users-list',
    components: { 
      default: UsersList,
    },
  }, {
    path: ':id/profile',
    name: 'user',
    components: { 
      default: UserRouter,
    },

    children: [{
      path: '',
      name: 'user-profile',
      components: { 
        default: UserProfile,
      },
    }]
  }, {
    path: ':id/entrepreneur/',
    name: 'user-entrepreneur',
    components: { 
      default: EntrepreneurRouter,
    },

    children: [{
      path: ':entrepreneur_id/profile/',
      name: 'entrepreneur-profile',
      components: { 
        default: EntrepreneurProfile,
      },
    }, {
      path: ':entrepreneur_id/activity/',
      name: 'entrepreneur-activity',
      components: { 
        default: EntrepreneurActivity,
      },
    }, {
      path: ':entrepreneur_id/billing/',
      name: 'entrepreneur-billing',
      components: { 
        default: EntrepreneurBilling,
      },
    }]
  }, {
    path: ':id/mandate/',
    name: 'user-mandate',
    components: { 
      default: UserMandate,
    },
  }, {
    path: ':id/subscription/',
    name: 'user-subscription',
    components: { 
      default: UserSubscription,
    },
  }, {
    path: ':id/documents',
    name: 'user-documents',
    components: { 
      default: DocumentsRouter,
    },

    children: [{
      path: '',
      name: 'documents-list',
      components: { 
        default: DocumentsList,
      },
    }, {
      path: ':document_id/infos/',
      name: 'document-infos',
      components: { 
        default: DocumentInfos,
      },
    }]
  }]
}